const loginSidePanel = function (titleType) {
    const $sidePanel = $('.login-side-panel');
    const $panelImage = $('.loginPanelImage');

    const openSidePanel = function () {

        let ssoPanelCookieValue = TINK.getCookie('ssoPanelView');
        let newPanelViewValue;
        if (ssoPanelCookieValue < 5) {
            newPanelViewValue = Number(ssoPanelCookieValue) + 1;
        }  else {
            newPanelViewValue = 1;
        }
        TINK.setCookie('ssoPanelView', newPanelViewValue);
        $panelImage.attr('src', '/images/shared/login-pannel-user-' + newPanelViewValue + '.png?v=' + buildVersion);

        $('.login-panel__top h3').addClass('hide');
        $sidePanel.remodal().open();

        switch(titleType) {
            case 'favourite':
                $('.title-favourite').removeClass('hide');
                $sidePanel.attr('forwarding-url-type', titleType);
                break;
            case 'coupons':
                $('.title-coupons').removeClass('hide');
                $sidePanel.attr('forwarding-url-type', titleType);
                break;
            case 'quickShop':
            case 'previous-purchases':
                $('.title-previous').removeClass('hide');
                $sidePanel.attr('forwarding-url-type', titleType);
                break;
            case 'orders':
                $('.title-orders').removeClass('hide');
                $sidePanel.attr('forwarding-url-type', titleType);
                break;
            default:
                $('.title-default').removeClass('hide');
                $sidePanel.removeAttr('forwarding-url-type');
        }

        $('.panel_header .close-side-panel.focusable').focus();
    };
    mainMenuNav.closeMenuNav();
    openSidePanel();
};

const submitLoginSignupForm = function (event) {
    event.preventDefault();
    let forwardingUrlType = $('.login-side-panel').attr('forwarding-url-type');
    if (forwardingUrlType !== undefined) {
        addDataToForm('#loginSidePanelForm', {
            'forwarding-url-type': forwardingUrlType
        });
    }
    let $submitButton = $(event.target);
    let url = $submitButton.data('url');
    $('#loginSidePanelForm').attr('action', url).submit();
}

const addDataToForm = function(form, data) {
    try {
        if (typeof form === 'string') {
            if (form[0] === '#') {
                form = form.slice(1);
            }
            form = document.getElementById(form);
        }

        let keys = Object.keys(data);
        let name, value, input;

        for (let i = 0; i < keys.length; i++) {
            name = keys[i];
            Array.prototype.forEach.call(form.elements, function (inpt) {
                if (inpt.name === name) {
                    inpt.parentNode.removeChild(inpt);
                }
            });

            value = data[name];
            input = document.createElement('input');
            input.setAttribute('name', name);
            input.setAttribute('value', value);
            input.setAttribute('type', 'hidden');

            form.appendChild(input);
        }
    } catch (e) {
    }

    return form;
}